module.exports = __webpack_public_path__ + "img/20231123_185123-2.41f84b30.jpg";